
export default function AboutSection() {
  return (
    <section id="about" className="py-32 bg-white relative overflow-hidden">
      {/* Subtle background pattern */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-20 w-32 h-32 border border-amber-400 rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 border border-amber-400 rounded-full"></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 border border-amber-400 rounded-full"></div>
      </div>

      <div className="max-w-6xl mx-auto px-8 text-center relative z-10">
        {/* Section Header */}
        <div className="mb-20">
          <div className="inline-flex items-center mb-6">
            <div className="w-16 h-px bg-amber-400"></div>
            <span 
              className="mx-6 text-amber-600 text-sm tracking-[0.3em] font-light uppercase"
              style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
            >
              About
            </span>
            <div className="w-16 h-px bg-amber-400"></div>
          </div>
          
          <h2 
            className="text-5xl md:text-6xl font-light text-gray-900 mb-6 tracking-wide"
            style={{ 
              fontFamily: '"Noto Serif JP", serif',
              letterSpacing: '0.02em'
            }}
          >
            Butler Bell
          </h2>
          
          <p 
            className="text-xl text-amber-600 font-light tracking-wide"
            style={{ fontFamily: '"Noto Sans JP", sans-serif' }}
          >
            全日本執事協会 3代目会長
          </p>
        </div>

        {/* Profile Image */}
        <div className="mb-16 flex justify-center">
          <div className="relative group">
            {/* Elegant glow effect */}
            <div className="absolute -inset-4 bg-gradient-to-r from-amber-400/20 via-amber-300/10 to-amber-400/20 rounded-full blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-700"></div>
            
            {/* Main profile image */}
            <div className="relative w-64 h-64 rounded-full overflow-hidden border-4 border-amber-400/30 shadow-2xl">
              <img
                src="/images/generated/3b901e53cb6d8a8b09c7b5b934c5e1c4.jpg"
                alt="Butler Bell - 執事ベル"
                className="w-full h-full object-cover object-top"
                onError={(e) => {
                  e.currentTarget.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"%3E%3Crect width="100" height="100" fill="%23f3f4f6"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%239ca3af" font-family="sans-serif" font-size="14"%3ENo Image%3C/text%3E%3C/svg%3E';
                }}
              />
              
              {/* Subtle overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/10 to-transparent"></div>
            </div>
            
            {/* Decorative ring */}
            <div className="absolute -inset-6 border border-amber-400/20 rounded-full"></div>
            <div className="absolute -inset-8 border border-amber-400/10 rounded-full"></div>
          </div>
        </div>

        {/* Profile Description */}
        <div className="max-w-6xl mx-auto mb-16">
          <p 
            className="text-lg md:text-xl text-gray-700 leading-relaxed font-light mb-8"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              lineHeight: '1.9'
            }}
          >
            全日本執事協会3代目会長として、日本における執事文化の普及と発展に取り組んでいます。西洋の伝統的な執事文化と日本固有のおもてなし精神を融合させた、新しい執事像を追求しています。
          </p>
          
          <p 
            className="text-lg text-gray-600 leading-relaxed font-light"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              lineHeight: '1.9'
            }}
          >
            真のエレガンスとは、相手への深い思いやりと、洗練された所作の調和から生まれるもの。執事文化の研究と実践を通じて日々学び続けている知見を、皆様と共有することを大切にしています。
          </p>
        </div>

        {/* Elegant CTA */}
        <div className="flex justify-center">
          <a
            href="#profile"
            className="group relative inline-flex items-center border-2 border-amber-400 text-amber-600 hover:bg-amber-800 hover:text-white px-10 py-4 font-light text-lg transition-all duration-500 overflow-hidden cursor-pointer"
            style={{ 
              fontFamily: '"Noto Sans JP", sans-serif',
              letterSpacing: '0.1em'
            }}
            onClick={(e) => {
              e.preventDefault();
              const element = document.getElementById('profile');
              if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
              }
            }}
          >
            <span className="relative z-10 mr-3">Profile Details</span>
            <i className="ri-arrow-right-line relative z-10 text-xl group-hover:translate-x-1 transition-transform duration-300"></i>
            
            {/* Hover background */}
            <div className="absolute inset-0 bg-amber-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left"></div>
            
            {/* Decorative elements */}
            <div className="absolute -top-1 -left-1 w-4 h-4 border-l-2 border-t-2 border-amber-400/40 group-hover:border-white/40 transition-colors duration-500"></div>
            <div className="absolute -bottom-1 -right-1 w-4 h-4 border-r-2 border-b-2 border-amber-400/40 group-hover:border-white/40 transition-colors duration-500"></div>
          </a>
        </div>
      </div>

      {/* Elegant section divider */}
      <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-32 h-px bg-gradient-to-r from-transparent via-amber-400/50 to-transparent"></div>
    </section>
  );
}
